// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"503":"c3bb94e3","952":"c7908757"}[chunkId] + ".chunk.css";
};